import { ProductType } from './enums';
import { type Box, type Experience, type Product, type ValueVoucher } from './types';

function isBox(product: Product): product is Box {
    return product.type === ProductType.BOX;
}

function isExperience(product: Product): product is Experience {
    return product.type === ProductType.EXPERIENCE;
}

function isValueVoucher(product: Product): product is ValueVoucher {
    return product.type === ProductType.VALUE_VOUCHER;
}

function isValueVoucherWithPriceRange(product: Product): product is ValueVoucher {
    return product.type === ProductType.VALUE_VOUCHER && !!product.priceHasRange;
}

export { isBox, isExperience, isValueVoucher, isValueVoucherWithPriceRange };
